import Cookies from 'js-cookie';

import { isSSR } from './helpers';

export const MS_API_URL_COOKIE_NAME = 'selfservice';

const LOCAL_PROXY_MS_API_URL = '/ms';
const DEV_MS_API_URL = 'https://dev.test-my.telia.lt';
const PROD_MS_API_URL = 'https://my.telia.lt';

export const MS_API_FALLBACK_URL =
    isSSR() || window.location.host === 'www.telia.lt' ? PROD_MS_API_URL : DEV_MS_API_URL;

const getMSApiUrl = () => {
    if (process.env.IS_PROXY_MODE === 'true') {
        if (isSSR()) {
            return process.env.TARGET_MS_ORIGIN;
        } else {
            return LOCAL_PROXY_MS_API_URL;
        }
    }

    const envApiUrl = isSSR() ? process.env.HUDSON_INTERNAL_URL : process.env.HUDSON_PUBLIC_URL;
    if (envApiUrl) {
        return envApiUrl;
    }

    const apiUrl = Cookies.get(MS_API_URL_COOKIE_NAME);

    return apiUrl || MS_API_FALLBACK_URL;
};

export const MS_URL = getMSApiUrl();
